import { Fragment } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { solucoesFlow, flowSteps } from "@/mocks/solucoes";

export default function SolucoesFlow() {
  return (
    <section className="relative overflow-hidden bg-foreground-950 py-16 text-background-50 md:py-24">
      <div className="absolute inset-0 nx-grid opacity-25"></div>
      <div className="nx-glow absolute -bottom-24 left-1/4 h-[420px] w-[420px] animate-pulseGlow"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge={solucoesFlow.badge}
          badgeIcon="ri-route-line"
          title={solucoesFlow.title}
          description={solucoesFlow.description}
          tone="dark"
        />

        <div className="mt-14 flex flex-col gap-4 lg:flex-row lg:items-center">
          {flowSteps.map((step, index) => (
            <Fragment key={step.label}>
              <Reveal delay={index * 60} className="flex-1">
                <div className="flex h-full flex-col items-center rounded-xl border border-background-50/10 bg-background-50/5 p-5 text-center">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500/15 text-accent-300">
                    <i className={`${step.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <p className="mt-4 font-heading text-base font-semibold text-background-50">
                    {step.label}
                  </p>
                  <p className="mt-1.5 text-xs leading-relaxed text-background-300">
                    {step.description}
                  </p>
                </div>
              </Reveal>
              {index < flowSteps.length - 1 ? (
                <i
                  className="ri-arrow-right-line hidden shrink-0 text-xl text-background-50/30 lg:block"
                  aria-hidden="true"
                ></i>
              ) : null}
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}